module.exports = __webpack_public_path__ + "img/mode-single.ede30af3.png";